import React from 'react';

const InvestmentStrategy: React.FC = () => {
  return (
    <div className="investment-strategy">
      <section className="strategy-hero">
        <h1>Investment Strategy</h1>
        <p>Our Approach to Global Investment Success</p>
      </section>

      <section className="strategy-content">
        <div className="strategy-section">
          <h2>Our Investment Philosophy</h2>
          <p>We believe in a disciplined, research-driven approach to investment that focuses on long-term value creation while managing risk effectively.</p>
        </div>

        <div className="strategy-section">
          <h2>Key Investment Areas</h2>
          <ul>
            <li>Global Equities</li>
            <li>Fixed Income</li>
            <li>Alternative Investments</li>
            <li>Emerging Markets</li>
          </ul>
        </div>

        <div className="strategy-section">
          <h2>Risk Management</h2>
          <p>Our comprehensive risk management framework ensures that we protect our clients' investments while pursuing growth opportunities.</p>
        </div>
      </section>
    </div>
  );
};

export default InvestmentStrategy; 